import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { receiveError, receiveSuccess } from '../../store/actions/notificationAction';

import pickupOrderRemote from '../../api/pickupOrderRemote';

import User, { UserRoleType } from '../../models/User';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import PickupOrderModel from '../../models/PickupOrder';

import { PO_SCHEMA } from '../../utils/pickupOrder';

import moment, { Moment } from 'moment';
import MomentUtils from "@date-io/moment";

import DropOffOrder from './DropOffOrder';
import ConfirmationDialog from '../confirmation/ConfirmationDialog';
import deliveryCompanyRequestHandler from '../../api/deliveryCompanyRemote';
import TruckDriverData from '../../models/TruckDriverData';

interface DropOffOrderContainerProps {
  dropOffOrder: PickupOrderModel;
  receiveError: Function;
  receiveSuccess: Function;
  user: User;
  showDetails: boolean;
  pickupDate: Moment;
  showTruckerInfo?: boolean;
  backToList?: boolean;
  showLine: boolean;
  userRole : UserRoleType;
};

interface DropOffOrderContainerState {
  dropOffOrder: PickupOrderModel;
  editErrors: { pieces: { error: boolean, message: string }, weight: { error: boolean, message: string } };
  selectedDeliveryCompanyID: number | undefined;
  initialDeliveryCompanyID: number | undefined;
  selectedDriverID: number | undefined;
  initialDriverID: number | undefined;
  openDockOverloadModal: boolean;
  showTruckerInfo: boolean;
  showNotify: boolean;
  dropOffTimeCopy: string;
  dropOffDate: Moment | string;
  cutOffDate: Moment | string;
  cutoffTime: Moment | null;
  isDeleteLastAwbModalOpened: boolean;
  deleteLastAwbModalCallback: Function;
  deleteLastAwb: boolean;
  sendOrder: string;
};

class DropOffOrderContainer extends Component<DropOffOrderContainerProps, DropOffOrderContainerState> {

  state = {
    dropOffOrder: PO_SCHEMA,
    editErrors: {
      pieces: { error: false, message: '' },
      weight: { error: false, message: '' }
    },
    selectedDeliveryCompanyID: undefined,
    initialDeliveryCompanyID: undefined,
    selectedDriverID: undefined,
    initialDriverID: undefined,
    openDockOverloadModal: false,
    showTruckerInfo: true,
    showNotify: false,
    dropOffTimeCopy: '',
    dropOffDate: new MomentUtils().date(null),
    cutOffDate: new MomentUtils().date(null),
    cutoffTime: new MomentUtils().date(null),
    isDeleteLastAwbModalOpened: false,
    deleteLastAwbModalCallback: () => {},
    sendOrder: 'truckingCompany',
    deleteLastAwb: false
  }

  componentDidMount() {
    this.load();
  };

  componentDidUpdate(prevProps: DropOffOrderContainerProps) {

    if (prevProps.dropOffOrder !== this.props.dropOffOrder ) {
      this.load();
    }
  };

  load = (): void => {
    const dropOffDate: Moment | string = this.props.dropOffOrder.pickup_date ? this.props.dropOffOrder.pickup_date : new MomentUtils().date();
    const cutOffDate: Moment | string =  this.props.dropOffOrder.cutoff_date ? this.props.dropOffOrder.cutoff_date : new MomentUtils().date(null);
    const cutoffTime: Moment = this.props.dropOffOrder.cutoff_time ? moment(this.props.dropOffOrder.cutoff_time, "HHmm") : this.props.dropOffOrder.cutoff_date ? moment(this.props.dropOffOrder.cutoff_time, "HHmm") : new MomentUtils().date(null);
    const selectedDeliveryCompanyID: number | undefined = this.props.dropOffOrder.id_delivery_company ? this.props.dropOffOrder.id_delivery_company : undefined;
    const selectedDriverID: number | undefined = this.props.dropOffOrder.id_driver ? this.props.dropOffOrder.id_driver : undefined;
    
    this.setState({ 
      dropOffOrder: this.props.dropOffOrder, dropOffDate, cutOffDate, cutoffTime, selectedDeliveryCompanyID, selectedDriverID });
  };

  setContainerState = (data: any): void => {    
    this.setState(data);
  };

  handleFieldsInput = (fieldName: string, event: any): void => {

    const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };
    const value: string = event.target.value;

    switch (fieldName) {

      case 'bill_to': currentDO.bill_to.full_address = value; break;
      case 'deliver_to':
        currentDO.deliver_to = currentDO.deliver_to || {};
        currentDO.deliver_to.full_address = value; 
        break;
      case 'endorse_to':
        currentDO.endorse_to = currentDO.endorse_to || {}; 
        currentDO.endorse_to.full_address = value; 
        break;
      case 'pickup_from': currentDO.pickup_from.full_address = value; break;
      case 'poAdditionalInformation':
        currentDO.additional_info = value; 
        break;
      default: break;
    };

    this.setState({ dropOffOrder: currentDO });
  };

  handleSetDeliveryCompanyID = (deliveryCompanyID: number): void => {

    let delCompanyID: number | undefined = undefined ;
    
    if (deliveryCompanyID) {
      delCompanyID = deliveryCompanyID;
    };

    const dO: PickupOrderModel = { ...this.state.dropOffOrder };
    dO.id_delivery_company = delCompanyID;

    this.setState({ dropOffOrder: dO, selectedDeliveryCompanyID: delCompanyID, showTruckerInfo: false });
  };

  handleSetDriverID = (driverId: number): void => {

    let truckDriverId: number | undefined = undefined ;
    
    if (driverId) {
      truckDriverId = driverId;
    };
    const dO: PickupOrderModel = { ...this.state.dropOffOrder };
    dO.id_driver = truckDriverId;
    deliveryCompanyRequestHandler.getDriverById(driverId).then((resp: ApiResponse<TruckDriverData>) => {

      const truckDriver: TruckDriverData | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (truckDriver) {
        dO.delivery_company_name = truckDriver.company;
        dO.driver_vehichle_registration = truckDriver.plate;
        dO.driver_id = truckDriver.license;
        dO.maskedDriverId =  dO.driver_id ? dO.driver_id.replace(/.(?=.{4,}$)/g, '#') : dO.driver_id;
      }
      this.setState({ dropOffOrder: dO, selectedDriverID: truckDriverId, showTruckerInfo: true });

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  handleSelectPickUpTime = (): void => {
    this.setState({ openDockOverloadModal: true });
  };

  submitPickupOrder = (): void => {
    const dO: PickupOrderModel = { ...this.state.dropOffOrder };
    dO.id_delivery_company = this.state.selectedDeliveryCompanyID === 0 ? undefined : this.state.selectedDeliveryCompanyID;
    dO.id_driver = this.state.selectedDriverID === 0 ? undefined : this.state.selectedDriverID;

    if (this.state.showTruckerInfo === false) {
      dO.driver_name = '';
      dO.driver_id = '';
      dO.driver_id_type = '';
      dO.driver_vehichle_registration = '';
      dO.driver_contact = '';
    };

    let direct = this.state.sendOrder === 'driver' ? true : false;
    
    pickupOrderRemote.updatePickupOrder(dO, direct).then((resp: ApiResponse<PickupOrderModel>) => {

      const dO: PickupOrderModel | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (dO) {

        this.setState({
          dropOffOrder: dO,
          selectedDeliveryCompanyID: dO.id_delivery_company,
          showNotify: true
        });

        this.props.receiveSuccess('The DO has been successfully updated!');
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  handleCloseDockOverloadModal = (time: string): void => {

    if (time) {

      const setTime: string = time.replace('.', '');
      const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };
      
      currentDO.pickup_time = setTime;
      this.setState({ dropOffOrder: currentDO });
      
    };

    this.setState({ openDockOverloadModal: false });
  };

  maskon = () => {
    const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };
    currentDO.maskedDriverId =  currentDO.driver_id.replace(/.(?=.{4,}$)/g, '#');
    this.setState ({ dropOffOrder: currentDO });
  }

  handleClick = (event: any) => {
    const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };
    currentDO.maskedDriverId =  currentDO.driver_id;
    this.setState({ dropOffOrder: currentDO });
  }

  hideTruckerInfo = (): void => {
    this.setState({ showTruckerInfo: false });
  };

  resetPickupTime = (): void => {

    const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };
    const dropOffTimeCopy: string = currentDO.pickup_time;
    currentDO.pickup_time = '';

    this.setState({ dropOffOrder: currentDO, dropOffTimeCopy });
  };

  changedDeliveryCompany = (newDeliveryCompanyID: number): void => {

    const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };
    const sameDeliveryCompanyID: boolean = this.state.dropOffOrder.id_delivery_company === newDeliveryCompanyID;

    if (this.state.dropOffTimeCopy !== '') {
      currentDO.pickup_time = this.state.dropOffTimeCopy;
    };

    this.setState({
      selectedDeliveryCompanyID: newDeliveryCompanyID,
      showTruckerInfo: sameDeliveryCompanyID,
      dropOffOrder: currentDO,
      showNotify: false
    });
  };

  changedDriver = (newDriverID: number): void => {

    const currentDO: PickupOrderModel = { ...this.state.dropOffOrder };

    if (this.state.dropOffTimeCopy !== '') {
      currentDO.pickup_time = this.state.dropOffTimeCopy;
    };
    currentDO.id_driver = newDriverID
    deliveryCompanyRequestHandler.getDriverById(newDriverID).then((resp: ApiResponse<TruckDriverData>) => {

      const truckDriver: TruckDriverData | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (truckDriver) {
        currentDO.delivery_company_name = truckDriver.company;
        currentDO.driver_vehichle_registration = truckDriver.plate;
        currentDO.driver_id = truckDriver.license;
        currentDO.maskedDriverId =  currentDO.driver_id ? currentDO.driver_id.replace(/.(?=.{4,}$)/g, '#') : currentDO.driver_id;
      }
      
      this.setState({
        selectedDriverID: newDriverID,
        showTruckerInfo: true,
        dropOffOrder: currentDO,
        showNotify: false
      });
      if (error) {
        this.props.receiveError(error);
      };
    });

  };

  changePickupDate = (type: string, date: Moment): void => {

    const dO: PickupOrderModel = { ...this.state.dropOffOrder };
    switch(type) {
      case 'pickupDate' :
        const currentPickupDateStr = dO.pickup_date;
        const newPickupDateToString: string = moment(date).format('YYYYMMDD');
    
        if (currentPickupDateStr !== newPickupDateToString) {
    
          dO.pickup_date = newPickupDateToString;
          this.setState({ dropOffOrder: dO, dropOffDate: date });
        };
        break;
      case 'cutoffDate' :
        const currentCutoffDateStr: string = dO.cutoff_date;
        const newCutOffDateToString: string = moment(date).format('YYYYMMDD');
    
        if (currentCutoffDateStr !== newCutOffDateToString) {
    
          dO.cutoff_date = newCutOffDateToString;
          this.setState({ dropOffOrder: dO, cutOffDate: date });
        };
        break;
      case 'cutoffTime' :
        const currentCutoffTimeStr: string = dO.cutoff_time;
        const newCutOffTimeToString: string = moment(date).format('HHmm');
    
        if (currentCutoffTimeStr !== newCutOffTimeToString) {
    
          dO.cutoff_time = newCutOffTimeToString;
          this.setState({ dropOffOrder: dO, cutoffTime: date });
        };
        break;
      default: break;
    }; 
  };

  changeDriverDetails = (type: string, event: any): void => {

    const dO: PickupOrderModel = { ...this.state.dropOffOrder };
    const value: string = event.target.value;
    switch(type) {
      case 'license' :
        dO.driver_id = value;
        this.setState({ dropOffOrder: dO });
        break;
      case 'plate' :
        dO.driver_vehichle_registration = value;
        this.setState({ dropOffOrder: dO });
        break;
      default: break;
    }; 
  };

  changeInputCutOffTime = (event: any) => {

    const dO: PickupOrderModel = { ...this.state.dropOffOrder };
    const newCutOffTimeToString: string = event.target.value;
    
    if (newCutOffTimeToString === '') {
    
      dO.cutoff_time = '';
      this.setState({ dropOffOrder: dO, cutoffTime: null });
    };
  }

  openLastAwbDeletionWarning = (callback: () => void) => {
    this.setState({isDeleteLastAwbModalOpened: true, deleteLastAwbModalCallback: () => {
      callback();
      this.setState({isDeleteLastAwbModalOpened: false, deleteLastAwb: true });
    }});
  }

  handleChangeSendOrder = (event: any): void => {

    const sendOrder: string = event.target.value;
    this.setState({ sendOrder})
  }

  render() {
    return (
      <Fragment>
        <DropOffOrder 
          dropOffOrder={ this.state.dropOffOrder }
          user={ this.props.user }
          setDriverID= { this.handleSetDriverID }
          selectedDriverID= { this.state.selectedDriverID }
          changedDriver= { this.changedDriver }
          initialDriverID= { this.state.initialDriverID }
          initialDeliveryCompanyID={ this.state.initialDeliveryCompanyID }
          showDetails={ this.props.showDetails }
          dropOffDate={ this.state.dropOffDate }
          cutOffDate={ this.state.cutOffDate }
          cutoffTime={ this.state.cutoffTime }
          showTruckerInfo={ this.state.showTruckerInfo }
          showNotify={ this.state.showNotify }
          selectedDeliveryCompanyID={ this.state.selectedDeliveryCompanyID }
          openDockOverloadModal={ this.state.openDockOverloadModal }
          editErrors={ this.state.editErrors }  
          handleSelectPickUpTime={ this.handleSelectPickUpTime }
          pickupDateChange={ this.changePickupDate }        
          handleFieldsInput={ this.handleFieldsInput }
          setContainerState={ this.setContainerState }
          hideTruckerInfo={ this.hideTruckerInfo }
          resetPickupTime={ this.resetPickupTime }
          handleSetDeliveryCompanyID={this.handleSetDeliveryCompanyID}
          changedDeliveryCompany={ this.changedDeliveryCompany }
          submitPickupOrder={ this.submitPickupOrder }
          handleCloseDockOverloadModal={ this.handleCloseDockOverloadModal }
          backToList={ this.props.backToList }
          changeInputCutOffTime={ this.changeInputCutOffTime}
          lastAwbDeletionWarning={ this.openLastAwbDeletionWarning }
          showLine={ this.props.showLine }
          sendOrder={ this.state.sendOrder}
          handleChangeSendOrder={ this.handleChangeSendOrder }
          userRole={this.props.userRole}
          changeDriverDetails={ this.changeDriverDetails }
          handleClick={ this.handleClick }
          maskOn={ this.maskon }
          deleteLastAwb={ this.state.deleteLastAwb }
        />
        { this.state.isDeleteLastAwbModalOpened && 
          <ConfirmationDialog
            open={ this.state.isDeleteLastAwbModalOpened }
            close={ () => { this.setState({ isDeleteLastAwbModalOpened: false }) } }
            title='Delete Confirmation'
            text={`You try to delete the last AWB in this Drop Off Order. \
            If you do this, the Drop Off Order will be marked with status “Deleted”. To confirm deletion, use \
            button “OK”. To cancel, use button “Cancel”.`}
            textConfirm='Ok'
            textCancel='Cancel'
            confirm={ this.state.deleteLastAwbModalCallback } 
            showCloseIcon={ true }
            showCancelButton={ true }
          />
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess:(message: string) => dispatch(receiveSuccess(message))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(DropOffOrderContainer);